import { browserHistory } from 'react-router'

import { getBanks } from 'reduxpath/ducks/Bank/List'

import { getCountryTaxes } from 'reduxpath/ducks/CountryTax/List'
import { getCountryTaxById } from 'reduxpath/ducks/CountryTax/Edit'
import { removeCountryTax } from 'reduxpath/ducks/CountryTax/Remove'

import {
  getCountries,
  setSelectionsCountry,
} from 'reduxpath/ducks/Reference'

import Home from 'units/CountryTax'
import List from 'units/CountryTax/units/List'
import Add from 'units/CountryTax/units/Add'
import Edit from 'units/CountryTax/units/Edit'

const list = (store) => {
  store.dispatch(
    getCountryTaxes({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
    }),
  )
}

const add = (store) => {
  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
    }, {}),
  )
  store.dispatch(getBanks({
    limit: 100000,
  }))
}

const edit = (store, id) => {
  store.dispatch(
    getCountryTaxById(id),
  )
  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
    }, {}),
  )
  store.dispatch(getBanks({
    limit: 100000,
  }))
}

const remove = (store, id) => {
  store.dispatch(
    removeCountryTax(id, () => {
      browserHistory.push('/country_taxes')
    }),
  )
}

export default {
  populate: {
    list,
    add,
    edit,
    remove,
  },
  components: {
    Home,
    List,
    Add,
    Edit,
  },
}
